import type { SVGProps } from 'react';

const SvgMoneyInvoice = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M16 3H8C6.35 3 5 4.35 5 6v12c0 1.65 1.35 3 3 3h8c1.65 0 3-1.35 3-3V6c0-1.65-1.35-3-3-3m1 15c0 .55-.45 1-1 1H8c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h8c.55 0 1 .45 1 1z"
    />
    <path
      fill="currentcolor"
      d="M12.31 11.05C11 10.61 11 10.29 11 10c0-.55.45-1 1-1 .26 0 .51.1.7.29.39.39 1.03.38 1.41-.02a.987.987 0 0 0-.02-1.41c-.32-.31-.69-.53-1.1-.67v-.18c0-.55-.45-1-1-1s-1 .45-1 1v.18c-1.16.41-2 1.51-2 2.82 0 2.06 1.88 2.68 2.69 2.95 1.31.42 1.31.78 1.31 1.05a1.003 1.003 0 0 1-1.87.5 1 1 0 0 0-1.37-.36c-.48.28-.64.89-.36 1.37.36.62.94 1.07 1.6 1.3v.2c0 .55.45 1 1 1s1-.45 1-1v-.18c1.16-.41 2-1.51 2-2.82 0-2.08-1.94-2.71-2.69-2.95z"
    />
  </svg>
);
export default SvgMoneyInvoice;
